import { VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { useBreakpointValue, Utils } from '@genial/utils';
import React from 'react';

import { CustomerDetailTypes } from '../..';
import { DynamicOrdinationProvider } from '../../../../contexts/DynamicOrdination';
import { securitiesTransferOrderByAtom } from '../../../../store/customerDetail/SecuritiesTransfer/filters';

import { Header } from './components/Header';
import { TableTransferRequests } from './components/TableTransferRequests';
import { tableHead } from './components/TableTransferRequests/constants';

export const SecuritiesTransfer: React.FC<CustomerDetailTypes.Props> = () => {
  const bg = useBreakpointValue({
    base: 'transparent',
    sm: 'neutral.white',
  }) as 'transparent' | 'neutral.white';

  return (
    <VStack
      bg={bg}
      borderRadius={BoxBorder.heavy}
      pb={Utils.Responsive.PhoneTablet({
        tablet: 0,
        phone: 'stack.md',
      })}>
      <DynamicOrdinationProvider orderAtom={securitiesTransferOrderByAtom} tableHead={tableHead}>
        <VStack
          space={Utils.Responsive.All({
            desktop: 'stack.xxs',
            tablet: 'stack.xxxs',
            phone: 'stack.xxxs',
          })}
          p={{ base: 'inline.nano', sm: 0 }}>
          <Header />
          <TableTransferRequests />
        </VStack>
      </DynamicOrdinationProvider>
    </VStack>
  );
};
